import { css } from 'linaria';

export const catalogGrid = css`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 578px 578px;
  grid-template-rows: 462px 266px 172px auto;
  width: 100%;
  padding: 0;
  margin-bottom: 32px;
  list-style: none;

  @media (--from-tablet) {
    :nth-child(1),
    :nth-child(3) {
      grid-row: auto / span 2;
    }
  }

  @media (--only-desktop) {
    grid-template-columns: 458px 458px;
    grid-template-rows: 391px 207px 160px auto;
  }

  @media (--only-tablet) {
    grid-template-columns: 318px 318px;
    grid-template-rows: 290px 138px 128px auto;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: 302px 113px auto;
    margin-bottom: 24px;
  }
`;
